module.exports = __webpack_public_path__ + "static/media/loader.24fe7524.svg";